module.exports = __webpack_public_path__ + "img/Cw-U_1-5x4_U1-2_30-DGU_f-Al_c-Al.5652a761.png";